import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["container", "hiddenSelectField", "selectedOptionLabel"];

	connect() {
		document.addEventListener("click", (e) => {
			this.closeSelectFieldsOnDocumentClick(e);
		});
	}

	toggle(e) {
		e.preventDefault();

		if (this.containerTarget.hasAttribute("data-group-toggle")) {
			this.containerTarget.removeAttribute("data-group-toggle");
		} else {
			this.containerTarget.setAttribute("data-group-toggle", true);
		}
	}

	closeSelectFieldsOnDocumentClick(e) {
		if (!this.containerTarget.contains(e.target)) {
			this.containerTarget.removeAttribute("data-group-toggle");
		}
	}

	selectOption(e) {
		e.preventDefault();

		const options = Array.from(
			this.hiddenSelectFieldTarget.querySelectorAll("option")
		);

		options.find(
			(c) => c.value == e.currentTarget.getAttribute("data-value")
		).selected = true;

		this.selectedOptionLabelTarget.innerHTML = e.currentTarget.innerHTML;

		this.containerTarget.removeAttribute("data-group-toggle");

		this.hiddenSelectFieldTarget.dispatchEvent(new Event("change"));
	}
}
